import { render, staticRenderFns } from "./ProductTags.vue?vue&type=template&id=188acdfe&scoped=true&"
import script from "./ProductTags.vue?vue&type=script&lang=js&"
export * from "./ProductTags.vue?vue&type=script&lang=js&"
import style0 from "./ProductTags.vue?vue&type=style&index=0&id=188acdfe&prod&lang=css&"
import style1 from "./ProductTags.vue?vue&type=style&index=1&id=188acdfe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188acdfe",
  null
  
)

export default component.exports